import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  BackButton,
  Error,
  Loading,
  PAMSSettingForm,
  ViewTitle,
} from '@iarcpsu/emanufac-components/src/components';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';

import * as actions from '../../redux/actions';

function SettingPAMS({ title, subtitle }) {
  const dispatch = useDispatch();
  const information = useSelector((state) => state.information);
  const { control, handleSubmit } = useForm();

  useEffect(() => {
    dispatch(actions.informationAll({}));
    return () => {};
  }, []);

  const onSubmit = async (data) => {
    try {
      await dispatch(
        actions.informationPut(information?._id, {
          ...information,
          setting: {
            ...information.setting,
            pams: data?.setting?.pams,
          },
        }),
      );
      alert('สำเร็จ');
      dispatch(actions.informationAll({}));
    } catch (error) {
      alert('การแก้ไขไม่สำเร็จ');
      console.error(error);
    }
  };

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  if (information.isLoading) {
    return <Loading />;
  }
  if (!information.isLoading && information.isCompleted) {
    return (
      <div>
        <div className="flex justify-between">
          <div>{renderTitle()}</div>
        </div>
        <div className="">
          <BackButton />
        </div>

        <div className="my-2">
          <form onSubmit={handleSubmit(onSubmit)}>
            <PAMSSettingForm
              control={control}
              pamsSetting={information?.setting?.pams}
            />
            <div className="flex justify-end my-2">
              <Button variant="contained" type="submit">
                บันทึก
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
  return <Error message={information?.message} />;
}

SettingPAMS.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

SettingPAMS.defaultProps = {
  title: '',
  subtitle: '',
};

export default SettingPAMS;
